export default {
  lang: {
    sale: "销售",
    title_sale: "销售管理",
    title_estimation: "报价管理",
    title_contract: "订单管理",
    title_trade: "交易账单管理",
    title_collection: "收款现状",
    title_uncollected: "未收款管理",
    invoice: "세금계산서",
    title_invoice: "税务发票管理",

    buy: "采购",
    title_buy: "采购管理",
    title_order: "采购订单管理",
    title_pay: "支付管理",
    title_unpaid: "未支付管理",

    production: "生产",
    title_production: "生产管理",
    title_plan: "生产计划管理",
    title_result: "生产绩效管理",
    title_pack: "包装管理",
    title_shipment: "出货管理",

    delivery: "交货",
    construction: "施工",
    goods: "货物",
    express: "快递",
    speedy: "快速",
    progress: "进展",
    shipment: "出货",

    stock: "物资",
    title_material: "物资管理",
    title_stock: "库存管理",
    title_stock_history: "库存变动记录",
    title_delivery: "出货现状",
    title_undelivered: "未出货管理",
    title_express: "出货企业登录",
    inbound: "入库",
    title_inbound: "入库现状",

    as: "A/S",
    title_as: "A/S管理",
    title_as_accept: "A/S接收管理",
    title_calendar: "A/S日程现状",
    title_collection_as: "A/S收款现状",

    title_receipt_list: "A/S接收列表",
    title_instruction_list: "A/S作业指示列表",
    title_completion_list: "A/S作业完成列表",
    title_billing_list: "A/S开具账单列表",
    title_as_dialog: "拥有产品添加登录",

    department: "部门",
    product_ownership_list: "产品拥有列表",
    code: "编号",
    operator_log_in_or_modify: "A/S作业者登录或者修改",

    workplace: "工作场景",
    account_classification: "账号分类",
    bill_cost: "折扣价",
    DC_amount: "DC金额",
    amount_received: "实收金额",
    collection_date: "收款日期",
    whether_collect: "是否收款",
    bill_amount: "账单金额",

    production_number: "生产编号",
    installation_site: "安装场所",
    receipt_date: "接收日期",
    access_date: "访问日期",
    address: "地址",
    receiver: "接收者",
    fault_symptom: "故障症状",
    cost: "费用",
    person_in_charge: "负责人",
    work_item: "工作事项",
    list_update: "列表更新",
    search_period: "搜索日期",

    management: "经营",
    title_management: "经营管理",
    title_receivablenote: "받을 어음관리",
    title_purchasenote: "결제 어음관리",

    base: "基础",
    title_base: "基础管理",
    title_code: "编号管理",
    title_customer: "客户管理",
    title_product: "物料管理",
    title_bom: "物料清单管理",
    title_safety: "安全库存管理",
    title_history: "变更记录",
    title_cost: "单价管理",

    system: "系统",
    title_system: "系统管理",
    title_user: "用户管理",
    title_group: "用户组管理",
    title_task: "生产工作管理",
    title_process: "生产工程管理",

    code_type: "编号分类",
    product: "物料",
    customer: "客户",
    estimation: "报价",
    contract: "订单",
    process: "工程",
    task: "工作",
    transaction: "交易",

    code_rule: "生成规则",

    base_price: "基本价格",

    No: "No",
    product_number: "产品编号",
    product_name: "产品名称",
    classify: "分类",
    material_name: "物料名称",
    material_classification: "物料分类",
    quantity: "数量",
    unit: "单位",
    search: "搜索",
    please_choose: "请选择",
    unitEA: "EA",
    user_id: "id",
    user_name: "姓名",
    user_tel: "电话",
    user_group: "组",
    last_login: "最后登陆时间",
    notes: "备注",

    created_at: "最初登录日",
    created_user_name: "最初登录者",
    modified_at: "最终修改日",
    modified_user_name: "最终修改者",
    desc: "备注",
    login_users: "登陆用户数",
    final_reviser: "最终修改人",
    final_reviser_date: "最终修改时间",
    group_name: "组名",
    have_authority: "有权限",
    no_authority: "无权限",
    task_name: "工作名称",
    task_user: "工作者",
    logged_person: "登陆人",
    logged_date: "登陆日",
    task_login: "工作登录",

    initial_login_date: "最初登陆日",
    process_name: "工程名称",
    work_number: "工作数",
    loginer: "登录者",
    change_date: "变更日",
    process_work_list: "工程工作列表",
    order: "顺序",
    work_one: "工作1",
    work_two: "工作2",

    purchase_number: "采购编号",
    id: "ID",
    material_color: "Color",
    material_size: "Size",
    warehousing_quantity: "入库数量",
    current_inventory: "当前库存",
    warehousing_date: "入库日期",
    state: "状态",

    detail_number: "明细编号",
    whether_issue: "是否发行",
    customer_name: "客户名",
    destination: "目的地",
    delivery_date: "交货日",
    phone_number: "电话号码",
    subscriber: "订购者",
    shipping_mode: "出货方式",

    list_title: "交易清单列表",
    issue: "是否发行",
    check: "验收",
    list_Packing: "包装记录列表",
    placeholder_pack: "编号, 客户名, 目的地",
    placeholder_plan: "No., initial login, sales category, product category",

    list_title_plan: "已登录的订单",
    contract_date: "订货日期",
    contract_code: "订货编号",
    contract_amount: "订货数量",
    production_amount: "生产登记",
    specifications: "规格",

    list_title_production_plan: "订单列表",
    production_plan_date: "生产计划日",
    project_number: "工程编号",

    work_instruction_list: "工作指示列表",
    material_number: "物料编号",
    current_quantity: "当前数量",
    safety_stock: "安全库存",
    production_performance_registration: "生产实绩登记",
    label: "标签",
    packing: "包装",

    material_inventory: "材料库存单",
    content: "内容",
    altered_person: "变更人",

    sales_classification: "销售分类",
    product_classification: "产品分类",
    categories: "细分类",
    material_logon: "物料登录",
    classification_composition_login: "分类构成登录",

    indication_quantity: "指示数量",
    result_quantity: "生产数量",
    bad_quantity: "不良数量",

    software_consulting:
      "소프트웨어 문의: (주)아브로소프트코리아 [Tel.02-2132-5115]",
    homepage: "http://www.avrosoft.co.kr",

    product_process: "제품공정",
    product_bom: "BOM",
    product_option: "옵션",
    collect: "수금",
    asset: "자산",
    service: "A/S",
    product_price: "제품단가",
    user: "사용자",
    note: "어음",
    size: "규격",
    production_num: "생산번호",
  },
  button: {
    login: "登录",
    add: "添加",
    search: "搜索",
    save: "保存",
    register: "登录",
    modify: "修改",
    delete: "删除",
    close: "关闭",
    yes: "是",
    no: "否",
    ok: "确定",
    cancel: "取消",
    login_modify: "登录或修改",

    serachTime: "日期区间",
    password_initialization: "密码初始化",

    packaging_acceptance: "包装验收",
    packaging_finish: "包装完成",
    list_printing: "列表打印",
    list_reprint: "列表再打印",
    packaging_cancelled: "包装取消",
    list_update: "列表更新",

    production_logon: "生产登录",
    production_cancel: "生产取消",
    production_Internal: "内部生产",
    production_num: "Production num",

    start_production: "开始生产",
    result_login: "结果登录",
    bad_login: "不良登录",
    production_completion: "生产完成",
    print_label: "打印标签",
    reissued_label: "重发标签",

    material_inventory: "Material inventory",
    safety_stock_login: "安全库存登录",
    manual_shipment: "手动出货",
    cancel_shipment: "出货取消",
    add_owned_products: "添加拥有产品",
  },
  message: {
    warn_code_total_length: "字符个数的中和不能超过20位.",
    wrong: "错误",
    cannot_be_repeated: "工程的所有工作不能重复",
    must_be_selected: "工作1必须进行选择",
    please_choose_task_name: "请选择工作名称",
    please_choose_task_user: "请选择工作者",
    please_choose_classify: "请选择分类",
    please_choose_code: "明细编号, 客户名",
    choose_date: "选择日期",
    please_choose: "请选择",
    please_enter_delivery_date: "请输入交货日",
    please_enter_customer: "请输入客户",
    please_enter_code: "请输入编号",
    please_enter_installation_site: "请输入安装场所",
    please_enter_product: "请输入物料",
    please_enter_color: "请输入颜色",
    please_enter_size: "请输入大小",
    please_enter_unit: "请输入单位",
    please_enter_quantity: "请输入数量",

    please_enter_the_receiving_date: "请输入接收日期",
    please_enter_the_access_date: "请输入访问日期",
    please_select_the_receiver: "请选择接收者",
    please_enter_the_fault_details: "请输入故障详情",
    please_enter_price: "请输入金额",
    please_enter_discount_price: "请输入折扣金额",
    please_enter_collected_price: "请输入实收金额",
  },
};
